import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Em produção, silencia console.log/warn/debug pra não poluir DevTools
// dos usuários. Mantém console.error pra erros críticos serem rastreáveis.
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.warn = noop;
  console.debug = noop;
  console.info = noop;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
